/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Close_AriaInputs */

const en_search_close_aria = /** @type {(inputs: Search_Close_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close search`)
};

const zh_hans1_search_close_aria = /** @type {(inputs: Search_Close_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭搜索`)
};

const pt_br2_search_close_aria = /** @type {(inputs: Search_Close_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar pesquisa`)
};

const es_search_close_aria = /** @type {(inputs: Search_Close_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar búsqueda`)
};

const fr_search_close_aria = /** @type {(inputs: Search_Close_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer la recherche`)
};

const de_search_close_aria = /** @type {(inputs: Search_Close_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suche schließen`)
};

const ru_search_close_aria = /** @type {(inputs: Search_Close_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть поиск`)
};

const it_search_close_aria = /** @type {(inputs: Search_Close_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi la ricerca`)
};

/**
* | output |
* | --- |
* | "Close search" |
*
* @param {Search_Close_AriaInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const search_close_aria = /** @type {((inputs?: Search_Close_AriaInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Close_AriaInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_search_close_aria(inputs)
	if (locale === "pt-BR") return pt_br2_search_close_aria(inputs)
	if (locale === "es") return es_search_close_aria(inputs)
	if (locale === "fr") return fr_search_close_aria(inputs)
	if (locale === "de") return de_search_close_aria(inputs)
	if (locale === "ru") return ru_search_close_aria(inputs)
	if (locale === "it") return it_search_close_aria(inputs)
	return en_search_close_aria(inputs)
});